import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function Button({
  children,
  className = '',
  onClick,
  href
}: ButtonProps) {
  const baseStyles = 'inline-block w-full md:w-auto text-center bg-[#F59E0B] hover:bg-[#D97706] text-black font-black text-xl md:text-2xl py-4 px-8 rounded-lg shadow-[0_0_20px_rgba(245,158,11,0.4)] transition-all transform hover:scale-105 active:scale-95 uppercase tracking-wide';
  if (href) {
    return <a href={href} className={`${baseStyles} ${className}`} data-id="element-195">
        {children}
      </a>;
  }
  return <button onClick={onClick} className={`${baseStyles} ${className}`} data-id="element-196">
      {children}
    </button>;
}